module.exports = __webpack_public_path__ + "static/media/permohonan_dana.d19527f9.png";